import React from 'react';
import PropTypes from 'prop-types';
import { KanbanCards } from '@/assets/images';
import translate from '@/lib/intl/translate';

function EmptyLifecycleLane({ children, name }) {
  const title = name
    ? translate('BOARD_CATEGORY_EMPTY_TITLE', { title: name })
    : translate('BOARD_DEFAULT_EMPTY_TITLE');
  return (
    <div className="text-center">
      <img src={KanbanCards} className="mx-auto my-3" alt="" />
      <p className="type-body2">{title}</p>
      <hr className="mx-auto my-4 w-32 border-grey-600" />
      <p className="text-text-secondary">
        {children || translate('BOARD_DEFAULT_EMPTY_DESCRIPTION')}
      </p>
    </div>
  );
}

EmptyLifecycleLane.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
};

EmptyLifecycleLane.defaultProps = {
  children: null,
  name: null,
};

export default EmptyLifecycleLane;
